export const FINANCIAL_SUMMARY_RECEIVED = 'FINANCIAL_SUMMARY_RECEIVED'
export const FINANCIAL_SUMMARY_UNLOADED = 'FINANCIAL_SUMMARY_UNLOADED'